import {createSelector} from '@reduxjs/toolkit'

import {APIStatus, MobileEasyPayPinStatus, MobileEasyPayPinStatusType} from '@web/core/constants'
import {addPhoneNumberHyphen} from '@web/helpers/policies'

import {RootState} from './interfaces'

export const mobileSelector = (state: RootState) => state.mobile

/** 휴대폰 번호 마스킹 처리 */
function maskPhoneNumbers(
    /** 휴대폰 번호 */
    phoneNumber: string,
): string {
    const numbers = addPhoneNumberHyphen(phoneNumber).split('-')
    // 최소 자리수
    const phoneNumberMinLengths = [2, 3, 4]
    if (
        !(
            numbers.length === 3 &&
            phoneNumberMinLengths.every((minLength, idx) => (numbers[idx]?.length ?? 0) >= minLength)
        )
    ) {
        return ''
    }
    return [numbers[0], numbers[1], '****'].join('-')
}

const mobilePinUpdatingState: MobileEasyPayPinStatusType[] = [
    MobileEasyPayPinStatus.CHANGE,
    MobileEasyPayPinStatus.CLEAN,
]
/** 휴대폰 간편결제 정보 selector */
export const mobileEasyPayInfoSelector = createSelector(
    (state: RootState) => state.mobile.mobileEasyPay,
    ({
        isRegistration,
        phoneNumbers,
        pinNo,
        newPinNo,
        confirmPinNo,
        pinStatus,
        apiStatus,
    }): {
        /** 모바일 간편결제 등록 여부 */
        isRegistration: boolean
        /** 핀 번호 (비밀번호) */
        pinNo: string
        /** 변경할 핀 번호 (비밀번호) */
        newPinNo: string
        /** 재입력된 변경할 핀 번호 (비밀번호) */
        confirmPinNo: string
        /** 핀 번호 상태 */
        pinStatus: 'IDLE' | 'CHANGE' | 'FORGOT' | 'CLEAN'
        /** 입력한 휴대폰 번호 */
        phoneNumbers: string
        /** 핀 번호 변경 상태중 여부 */
        isUpdatingPin: boolean
        /** 간편결제 가입정보 변경중 여부 */
        isUpdatingPinMembership: boolean
        /** 외부 api의 정보변경 기다림 여부 */
        isFetchingUpdatedData: boolean
        /** 마스킹된 휴대폰 번호 */
        maskedPhoneNumbers: string
    } => {
        return {
            isRegistration,
            pinNo,
            newPinNo,
            confirmPinNo,
            pinStatus,
            phoneNumbers,
            isUpdatingPin: pinStatus === MobileEasyPayPinStatus.CHANGE,
            isUpdatingPinMembership: mobilePinUpdatingState.includes(pinStatus),
            isFetchingUpdatedData: apiStatus === APIStatus.FETCHING,
            maskedPhoneNumbers: isRegistration ? maskPhoneNumbers(phoneNumbers) : '',
        }
    },
)

/** 휴대폰 일반결제 정보 selector */
export const mobileGeneralPayInfoSelector = createSelector(
    (state: RootState) => state.mobile.mobileGeneralPay,
    ({
        phoneNumbers,
    }): {
        /** 휴대폰 번호 */
        phoneNumbers: string
    } => {
        return {
            phoneNumbers,
        }
    },
)
